/** Stream covers fill the thumb; Live TV stays a contained channel mark. */
const COVER_PLATFORMS = new Set(['twitch', 'kick', 'youtube', 'concert']);

export function eventUsesCoverFill(event) {
  const platform = String(event?.platform || '').toLowerCase();
  if (platform === 'epg' || !COVER_PLATFORMS.has(platform)) return false;
  if (platform === 'concert') {
    return hasArtUrl(event?.thumbnail) || hasArtUrl(event?.logo);
  }
  return hasArtUrl(event?.thumbnail);
}

function hasArtUrl(value) {
  const raw = typeof value === 'string' ? value.trim() : '';
  if (!raw || /placehold\.co/i.test(raw)) return false;
  try {
    const url = new URL(raw);
    return url.protocol === 'http:' || url.protocol === 'https:';
  } catch {
    return raw.startsWith('/assets/');
  }
}
